import React, { useEffect, useState } from "react";
import styles from "./../styles.module.scss";
import { Button, FilterDropdown, TextInput } from "components";
import { useDispatch, useSelector } from "react-redux";
import { subCategoriesAction, categoryAction } from "redux/actions";

export default function RoutingDetails({ onClick, details, setDetails }) {
  const dispatch = useDispatch();
  const categories = useSelector(state => state.categories);
  const [classTime, setClassTime] = useState([{ value: "" }]);

  const handleChange = (index, event) => {
    const newclassTimes = [...classTime];
    classTime[index].value = event.target.value;
    setClassTime(newclassTimes);
    details.class_time = JSON.stringify(newclassTimes);
  };

  const addMore = () => {
    setClassTime([...classTime, { value: "" }]);
  };

  const removeField = (index) => {
    const newclassTimes = classTime.filter((_, i) => i !== index);
    setClassTime(newclassTimes);
  };

  useEffect(() => {
    console.log(JSON.stringify(details));
      dispatch(categoryAction.get());
    }, []);
  

    const get = categoryID => {
        if (!categoryID) return;
        dispatch(subCategoriesAction.get(categoryID));
      };
    

  return (
    <div className={styles.main__container}>

      <TextInput
        label="Session From Date"
        placeholder="Session From Date"
        name="from_date"
        onChange={setDetails}
        value={details?.from_date}
        type="date"
        min="0"
      />

      <TextInput
        label="Session To Date"
        placeholder="Session To Date"
        name="to_date"
        onChange={setDetails}
        value={details?.to_date}
        type="date"
        min="0"
      />

      {classTime.map((input, index) => (
        <div key={index} className="flex gap-2 mb-2">

        <TextInput
          label="Class Time"
          placeholder="Class Time"
          name="class_time[]"
          onChange={(e) => handleChange(index, e)}
          value={input.value}
          type="time"
        />
          {index > 0 && (
            <Button onClick={() => removeField(index)} title="Remove" />
          )}
        </div>
      ))}
      <Button onClick={addMore} title="+ Add More" />

      

      <div className={styles.btn__container}>
        <Button title="Generate" onClick={onClick} />
      </div>
    </div>
  );
}
